import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

// Cache a livello di modulo: <Layout> si rimonta ad ogni cambio di route,
// senza cache ogni navigazione rifarebbe la GET dei preferiti. La cache vive
// per la durata della SPA; logout/cambio utente fanno full reload e la azzerano.
let cache: string[] | null = null;
let inflight: Promise<string[]> | null = null;

async function caricaPreferiti(): Promise<string[]> {
  if (cache) return cache;
  if (!inflight) {
    // @api GET /api/menu-preferiti -> {"success":true,"data":["/percorso/voce"]}
    inflight = apiFetch<{ success: boolean; data: string[] }>('/api/menu-preferiti')
      .then(res => {
        cache = res.data ?? [];
        return cache;
      })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useMenuPreferiti() {
  const [preferiti, setPreferiti] = useState<string[]>(cache ?? []);

  useEffect(() => {
    let attivo = true;
    caricaPreferiti()
      .then(paths => { if (attivo) setPreferiti(paths); })
      .catch(err => console.error('[useMenuPreferiti] caricamento fallito', err));
    return () => { attivo = false; };
  }, []);

  const togglePreferito = useCallback((path: string) => {
    const prima = cache ?? [];
    const nuovo = prima.includes(path) ? prima.filter(p => p !== path) : [...prima, path];
    cache = nuovo; // aggiornamento ottimistico
    setPreferiti(nuovo);
    // @api POST /api/menu-preferiti/toggle {"path":"/percorso/voce"} -> {"success":true,"data":{"path":"/percorso/voce","preferito":true}}
    apiFetch<{ success: boolean; data: { path: string; preferito: boolean } }>('/api/menu-preferiti/toggle', {
      method: 'POST',
      body: JSON.stringify({ path }),
    }).catch(err => {
      console.error('[useMenuPreferiti] toggle fallito', err);
      cache = prima; // rollback
      setPreferiti(prima);
    });
  }, []);

  return { preferiti, togglePreferito };
}
